import React, { createContext, useState, useEffect } from 'react';
import * as authService from '../services/auth.service';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check for existing session on mount
  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    setLoading(true);
    try {
      const isAuth = await authService.isAuthenticated();

      if (isAuth) {
        const session = await authService.getCurrentSession();
        setUser({
          email: session.email,
          userId: session.userId,
        });
      } else {
        setUser(null);
      }
    } catch (err) {
      console.error('Auth check failed:', err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  async function login(email, password) {
    setError(null);
    try {
      const result = await authService.signIn(email, password);
      setUser({
        email: result.email,
        userId: result.userId,
      });
      return result;
    } catch (err) {
      setError(err.message || 'Login failed');
      throw err;
    }
  }

  async function logout() {
    setError(null);
    try {
      await authService.signOut();
      setUser(null);
    } catch (err) {
      setError(err.message || 'Logout failed');
      throw err;
    }
  }

  async function signup(email, password, givenName, familyName) {
    setError(null);
    try {
      const result = await authService.signUp(email, password, givenName, familyName);
      return result;
    } catch (err) {
      setError(err.message || 'Signup failed');
      throw err;
    }
  }

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    signup,
    isAuthenticated: !!user,
    checkAuth,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
